import { fecthGet, fecthPost } from '@/hotelcem/apis/request'
import { Message } from 'element-ui'
import axios from 'axios'

async function requestPost(...params) {
  return fecthPost(...params).then(res => {
    if (res.code === 200) {
      return Promise.resolve(res.data)
    }
    if (res.code === -2000) {
      return Promise.resolve(null)
    }
    if (res.code !== 500 && res.code !== 200 && res.code !== 401) {
      Message.error({ message: res.msg })
    }
    return Promise.reject(res)
  })
}

async function requestGet(...params) {
  return fecthGet(...params).then(res => {
    if (res.code === 200) {
      return Promise.resolve(res.data)
    }
    if (res.code === -2000) {
      return Promise.resolve(null)
    }
    if (res.code !== 500 && res.code !== 200 && res.code !== 401) {
      Message.error({ message: res.msg })
    }
    return Promise.reject(res)
  })
}

export default {
  /**
   * 平均点评分排名
   * @param params
   * @returns
   */
  getAvgScoreRank(params) {
    return requestPost('/cem/hotel/compete-analysis/avg/score/rank', params)
  },
  /**
   * 平均点评分竞争指数
   * @param params
   * @returns
   */
  getAvgScoreRankIndex(params) {
    return requestPost('/cem/hotel/compete-analysis/avg/score/index', params)
  },
  /**
   * 点评数量排名
   * @param params
   * @returns
   */
  getCountRank(params) {
    return requestPost('/cem/hotel/compete-analysis/comment/count/rank', params)
  },
  /**
   * 今日渠道竞争指数
   * @param params
   * @returns
   */
  getChannelRankIndex(params) {
    return requestPost('/cem/hotel/compete-analysis/channel/score/index', params)
  },
  /**
   * 差评率排名
   * @param params
   * @returns
   */
  getNegativeRank(params) {
    return requestPost('/cem/hotel/compete-analysis/negative-comment/rank', params)
  },
  /**
   * 差评率竞争指数
   * @param params
   * @returns
   */
  getNegativeRankIndex(params) {
    return requestPost('/cem/hotel/compete-analysis/negative/rank/index', params)
  },
  /**
   * 差评回复率排名
   * @param params
   * @returns
   */
  getNegativeReplyRank(params) {
    return requestPost('/cem/hotel/compete-analysis/negative-comment/reply/rank', params)
  },
  /**
   * 今日CSI竞争指数
   * @param params
   * @returns
   */
  getTodayCSIIndex(params) {
    return requestPost('/cem/hotel/compete-analysis/csi/index', params)
  },
  /**
   * 好评率排名
   * @param params
   * @returns
   */
  getPositiveRank(params) {
    return requestPost('/cem/hotel/compete-analysis/positive-comment/rank', params)
  },
  /**
   * 好评率竞争指数
   * @param params
   * @returns
   */
  getPositiveRankIndex(params) {
    return requestPost('/cem/hotel/compete-analysis/positive/rank/index', params)
  },
  /**
   * 竞争对手详细数据列表
   * @param params
   * @returns
   */
  getCompetitorList(params, cancelSource) {
    const url = '/cem/hotel/compete-analysis/competitor/detail'
    const cancel = cancelSource[url]
    if (cancel && Object.prototype.toString.call(cancelSource[url]) === '[object Function]') {
      cancel({
        code: -2000,
        message: 'The user actively cancels the request',
      })
    }
    return requestPost(url, params, {
      cancelToken: new axios.CancelToken(c => {
        cancelSource[url] = c
      }),
    })
  },
  /**
   * 竞争对手数据趋势
   * @param params
   * @returns
   */
  getCompetitorTrend(params) {
    return requestPost('/cem/hotel/compete-analysis/competitor/detail/trend', params)
  },
  /**
   * 竞争对手指数数据趋势
   * @param params
   * @returns
   */
  getCompetitorTrendIndex(params) {
    return requestPost('/cem/hotel/compete-analysis/competitor/detail/index', params)
  },
  /**
   * 点评数量统计
   * @param params
   * @returns
   */
  getCommonentCount(params) {
    return requestPost('/cem/hotel/compete-analysis/comment/count', params)
  },
  /**
   * 是否纯在竞对圈
   * @param params
   * @returns
   */
  getCompeteStatus(params) {
    return requestGet('/cem/hotel/competitor/status', params)
  },
  /**
   * 下载数据详情
   * @param params
   * @returns
   */
  downloadDetail(params) {
    return requestPost('/cem/hotel/compete-analysis/export', params)
  },

  // 竞对TOP10 标签
  getCompeteTopTag(data) {
    return requestPost('/cem/hotel/compete-analysis/competitor-label/rank', data)
  },

  // 获取竞对点评观点排名数据
  getCompeteCommentViewRank(data) {
    return requestPost('/cem/hotel/compete-analysis/label/rank', data)
  },
  // 获取竞对点评观点排名汇总
  getCompeteCommentViewTotal(data) {
    return requestPost('/cem/hotel/compete-analysis/label/rank/summarizing', data)
  },
  // 下载竞对点评观点排名数据
  downloadCompeteCommentViewRank(data) {
    return requestPost('/cem/hotel/compete-analysis/label/rank/export', data)
  },
}
